import { combineReducers } from 'redux';
import { APIReducer } from 'store/apiReducer';
import {
    CONTEXT_DELETE_REPRISE_DE_DONNEES_ARME,
    CONTEXT_GET_REPRISE_DE_DONNEES_ARME,
    CONTEXT_GET_REPRISE_DE_DONNEES_ARME_BY_UNIQID,
    CONTEXT_MODIFIER_REPRISE_DE_DONNEES_ARME,
} from '../../constants/apiUrls.constants';

const repriseDeDonnees = combineReducers({
    recupererArmes: APIReducer.bind(null, CONTEXT_GET_REPRISE_DE_DONNEES_ARME),
    recupererArme: APIReducer.bind(null, CONTEXT_GET_REPRISE_DE_DONNEES_ARME_BY_UNIQID),
    supprimerArme: APIReducer.bind(null, CONTEXT_DELETE_REPRISE_DE_DONNEES_ARME),
    modifierArme: APIReducer.bind(null, CONTEXT_MODIFIER_REPRISE_DE_DONNEES_ARME),
});

export default repriseDeDonnees;
